<template>
  <div class="main">
    <Header :show="show" @listenEvent="fn" @listenHeight="getHeight" />
    <div
      class="imgshowbox"
      @click="changeShow"
      :style="'margin-top:' + msgboxTop + 'px'"
    >
      <div class="container">
        <img class="titleimg" src="../assets/images/topImg/3.jpg" alt="" />
        <div class="title-box">
          <div class="title-box-bottom">
            <h3 class="big-title">AI智能监控套包</h3>
            <p class="title-details">
              针对监控套包的庞大市场需求，我司研发推出全系列监控套包产品，如POE套包、XPOE套包、DVR套包、WIFI套包、低功耗WIFI套包、婴儿看护套包、混合WIFI套包、带屏同轴套包、带屏WIFI套包等，提供高品质、高性价比的产品，为广大客户提供全方位、一站式的产品解决方案服务，涵盖各种监控应用场景。
            </p>
            <van-button
              v-show="showVideo"
              round
              class="title-box-bottom-video"
              @click="
                () => {
                  this.$router.push({
                    name: 'video',
                    query: {
                      src:
                        'static/video/AIintelligentautonomouspackagesolution.mp4'
                    }
                  });
                }
              "
            >
              <van-icon :name="require('../assets/images/play.png')" />
              <span>AI智能自主套包解决方案</span>
            </van-button>
          </div>
        </div>
      </div>
      <div>
        <van-tabs v-model="active" swipeable animated>
          <van-tab
            v-for="item in messageList"
            :key="item.id"
            :title="item.title"
          >
            <div class="product-box">
              <div class="product-box-top">
                <p class="product-title">
                  {{ item.details }}
                </p>

                <div class="product-button">
                  <span v-for="list in item.buttonList" :key="list.id">
                    <router-link
                      :to="{ path: list.url, query: { src: list.src } }"
                    >
                      <van-button
                        class="title-box-bottom-video change-color"
                        round
                        ><van-icon :name="list.icon"></van-icon>
                        <span class="button-in-box">{{ list.text }}</span>
                      </van-button>
                    </router-link>
                  </span>
                </div>
              </div>

              <div
                class="product-box-middle"
                v-for="article in item.articleList"
                :key="article.id"
              >
                <div class="img-box">
                  <van-image width="100%" fit="contain" :src="article.src" />

                  <div>
                    <h4>{{ article.articletitle }}</h4>
                    <span class="product-details"
                      >{{ article.articledetails }}
                    </span>
                    <div v-for="list in article.traitList" :key="list.id">
                      <h5>{{ list.lightTitle }}</h5>
                      <p v-for="(light, index) in list.lightList" :key="index">
                        {{ light.light }}
                      </p>
                    </div>
                  </div>
                  <p class="linkmore" v-show="article.have">
                    <a :href="article.href">了解更多>>></a>
                  </p>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
export default {
  components: { Header },
  data() {
    return {
      src: "/video",
      show: false,
      active: 0,
      showVideo: true,
      msgboxTop: 0,

      messageList: [
        {
          id: 1,
          title: "网络WiFi套包",
          details:
            "WIFI套包产品，蕴含2MP、3MP、5MP、4K多种高清分辨率；450米超远距离传输，搭配人脸检测，人形检测等智能功能，带来更多智能体验",
          buttonList: [
            // {
            //   id: 1 - 1,
            //   icon: require("../assets/images/play.png"),
            //   text: "播放视频1",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // },
            // {
            //   id: 1 - 3,
            //   icon: require("../assets/images/ppt.png"),
            //   text: "播放视频3",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // }
          ],
          articleList: [
            {
              id: 1 - 1 - 1,
              src: require("../assets/images/newAdd/3.jpg"),
              articletitle: "网络智能WIFI监控套包",
              articledetails: "",
              traitList: [
                {
                  id: 1 - 1 - 1 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "支持H.265AI编码，低码流，低存储；"
                    },
                    {
                      light: "支持一键自动对码接入；"
                    },
                    {
                      light: "支持自动级联，快速确定最佳级联；"
                    },
                    {
                      light: "本地硬盘存储+云存储；"
                    },
                    {
                      light: "支持人形、人脸检测；"
                    },
                    {
                      light: "双WiFi套包支持连接无线路由器/做AP热点直连；"
                    },
                    {
                      light: "无需布线，有效解决布线繁琐的困扰；"
                    },
                    {
                      light: "移动性强 ，解决了有线移动性差的困扰。"
                    }
                  ]
                },
                {
                  id: 1 - 1 - 1 - 2,
                  lightTitle: "适用场景",
                  lightList: [
                    {
                      light:
                        "广泛应用于咖啡厅，面包店，服饰店，便利店，宠物店等多种监控应用场景"
                    }
                  ]
                }
              ],
              have: true,
              href: "http://www.jufenginfo.com/product-list-432-312.html"
            }
          ]
        },
        {
          id: 6,
          title: "低功耗WiFi套包",
          details:
            "低功耗摄像机套包无需布线，真正全无线。电池供电，无线配对，可安装在任何地方，安装简单方便。支持智能PIR人体红外感应、手机远程、红外夜视、云存储等功能，带来更多智能体验。",
          buttonList: [
            // {
            //   id: 1 - 1,
            //   icon: require("../assets/images/play.png"),
            //   text: "播放视频1",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // },
            // {
            //   id: 1 - 3,
            //   icon: require("../assets/images/ppt.png"),
            //   text: "播放视频3",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // }
          ],
          articleList: [
            {
              id: 6 - 1 - 1,
              src: require("../assets/images/newAdd/6.jpg"),
              articletitle: "低功耗摄像机监控套包",
              articledetails: "",
              traitList: [
                {
                  id: 6 - 1 - 1 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "无需布线，真正全无线"
                    },
                    {
                      light: "电池供电，无线配对"
                    },
                    {
                      light: "无线中枢网关集中接入存储"
                    },
                    {
                      light: "本地SD卡存储+云存储"
                    },
                    {
                      light: "超低功耗，超长续航"
                    },
                    {
                      light: "PIR人体检测，0.2秒快速启动"
                    },
                    {
                      light: "红外夜视，夜晚也能看清"
                    },
                    {
                      light: "双向语音对讲，通过APP随时随地沟通"
                    },
                    {
                      light: "手机短视频报警推送"
                    }
                  ]
                },
                {
                  id: 6 - 1 - 1 - 2,
                  lightTitle: "适用场景",
                  lightList: [
                    {
                      light:
                        "广泛应用于餐厅，面包店，服饰店，便利店，宠物店，家庭住宅等多种监控应用场景"
                    }
                  ]
                }
              ],
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-312.html"
            }
          ]
        },

        {
          id: 7,
          title: "婴儿看护套包",
          details:
            "婴儿看护套包产品，包含多种高清分辨率，支持360°旋转，双向语音对讲，可以实时查看婴儿状态",
          buttonList: [
            // {
            //   id: 1 - 1,
            //   icon: require("../assets/images/play.png"),
            //   text: "播放视频1",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // },
            // {
            //   id: 1 - 3,
            //   icon: require("../assets/images/ppt.png"),
            //   text: "播放视频3",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // }
          ],
          articleList: [
            {
              id: 7 - 1 - 1,
              src: require("../assets/images/newAdd/9.jpg"),
              articletitle: "网络智能婴儿看护套包",
              articledetails: "",
              traitList: [
                {
                  id: 7 - 1 - 1 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "高清显示屏，自带锂电池，随意携带"
                    },
                    {
                      light: "双向语音对讲，实时与宝宝对话"
                    },
                    {
                      light: "不用连接wifi，插电就能用"
                    },
                    {
                      light: "信号强，穿墙效果好，1-2层楼房都能用"
                    },
                    {
                      light: "夜视高清，夜晚也能看清宝宝状态"
                    },
                    {
                      light: "摇头机自带云台，360°旋转，实时查看宝宝状态"
                    }
                  ]
                },
                {
                  id: 7 - 1 - 1 - 2,
                  lightTitle: "适用场景",
                  lightList: [
                    {
                      light: "适用于婴儿房，育婴室，老人看护等监控应用场景"
                    }
                  ]
                }
              ],
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-312.html"
            }
          ]
        },
        {
          id: 8,
          title: "混合WIFI套包",
          details:
            "混合套包套包产品，包含2MP、3MP多种高清分辨率；超远距离传输，搭配人脸检测，人形检测等智能功能，带来更多智能体验",
          buttonList: [
            // {
            //   id: 1 - 1,
            //   icon: require("../assets/images/play.png"),
            //   text: "播放视频1",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // },
            // {
            //   id: 1 - 3,
            //   icon: require("../assets/images/ppt.png"),
            //   text: "播放视频3",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // }
          ],
          articleList: [
            {
              id: 8 - 1 - 1,
              src: require("../assets/images/newAdd/12.jpg"),
              articletitle: "网络智能混合套包",
              articledetails: "",
              traitList: [
                {
                  id: 8 - 1 - 1 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "支持H.265AI编码，低码流，低存储"
                    },
                    {
                      light: "支持一键自动对码接入"
                    },
                    {
                      light: "支持自动级联，快速确定最佳级联"
                    },
                    {
                      light: "本地硬盘存储+云存储"
                    },
                    {
                      light: "支持人形、人脸检测"
                    },
                    {
                      light: "产品种类全，室内、室外都能用"
                    }
                  ]
                },
                {
                  id: 8 - 1 - 1 - 2,
                  lightTitle: "适用场景",
                  lightList: [
                    {
                      light:
                        "适用于超市、办公、公司、学校、家庭、医院等监控应用场景"
                    }
                  ]
                }
              ],
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-312.html"
            }
          ]
        },
        {
          id: 2,
          title: "POE套包",
          details:
            "POE网络监控套包，与传统的监控套装相比，无需复杂布线，安装简单，能一根网线实现供电+信号传输，即插即用，秒出图，传输距离能达到300米（超五类）。并支持人脸检测，人形检测，人脸录像回放等智能功能，带来更多智能体验。",
          buttonList: [
            // {
            //   id: 2 - 1,
            //   icon: require("../assets/images/play.png"),
            //   text: "播放视频1",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // },
            // {
            //   id: 2 - 2,
            //   icon: require("../assets/images/ppt.png"),
            //   text: "播放视频3",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // }
          ],
          articleList: [
            {
              id: 2 - 1 - 1,
              src: require("../assets/images/newAdd/15.jpg"),
              articletitle: "网络智能POE监控套包",
              articledetails: "",
              traitList: [
                {
                  id: 2 - 1 - 1 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "内置POE模块 连接稳定"
                    },
                    {
                      light: "网线供电 安装方便"
                    },
                    {
                      light: "即插即用 快速出图"
                    },
                    {
                      light: "AI智能人脸检测，AI智能人形检测"
                    },
                    {
                      light: "本地硬盘存储+云存储"
                    },
                    {
                      light: "手机短视频报警推送"
                    },
                    {
                      light: "支持H.265AI编码，低码流，低存储"
                    },
                    {
                      light: "一根网线解决供电、视频传输、控制，减少布线成本"
                    },
                    {
                      light: "传输距离远，单根线可达300米（超5类线）"
                    },
                    {
                      light: "支持人形、人脸检测"
                    }
                  ]
                },
                {
                  id: 2 - 1 - 1 - 2,
                  lightTitle: "适用场景",
                  lightList: [
                    {
                      light:
                        "广泛应用于餐厅，面包店，服饰店，便利店，宠物店，家庭住宅等多种监控应用场景"
                    }
                  ]
                }
              ],
              have: true,
              href: "http://www.jufenginfo.com/product-list-432-433-435.html"
            }
          ]
        },
        {
          id: 3,
          title: "XPOE套包",
          details:
            "2MP/5MP XPOE监控套包，与传统的监控套装相比，XPOE监控套装无需复杂布线，安装简单，能一根网线实现传输供电+视频信号+控制型号，减少线材用量，节约成本，让工程布线更简洁干净。设备即插即用，秒出图。并支持人脸检测，人形检测，人脸录像回放等智能功能。",
          buttonList: [
            // {
            //   id: 3 - 1,
            //   icon: require("../assets/images/play.png"),
            //   text: "播放视频1",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // },
            // {
            //   id: 3 - 3,
            //   icon: require("../assets/images/ppt.png"),
            //   text: "播放视频3",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // }
          ],
          articleList: [
            {
              id: 3 - 1 - 1,
              src: require("../assets/images/newAdd/17.jpg"),
              articletitle: "XPOE监控套包",
              articledetails: "",
              traitList: [
                {
                  id: 3 - 1 - 1 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "内置XPOE供电模块 "
                    },
                    {
                      light: "一根网线实现供电+信号传输，安装方便"
                    },
                    {
                      light: "零延时、秒出图、即插即用"
                    },
                    {
                      light: "帧累积技术，降低噪点，提高亮度，夜视效果成倍增强"
                    },
                    {
                      light: "本地硬盘存储+云存储"
                    },
                    {
                      light: "手机短视频报警推送"
                    },
                    {
                      light: "支持H.265+编码，低码流，低存储"
                    },
                    {
                      light: "成本低，减少安装成本和维护费用"
                    },
                    {
                      light: "传输距离远，单根线可达150米"
                    }
                  ]
                },
                {
                  id: 3 - 1 - 1 - 2,
                  lightTitle: "适用场景",
                  lightList: [
                    {
                      light:
                        "广泛应用于商铺，住宅，街道，工厂，学校等多种监控应用场景"
                    }
                  ]
                }
              ],
              have: true,
              href: "http://www.jufenginfo.com/product-list-432-312.html"
            }
          ]
        },
        {
          id: 4,
          title: "DVR套包",
          details:
            "同轴套包产品，包含5M-N、8M-N多种高清分辨率；搭配人脸检测，人形检测等智能功能，带来更多智能体验",
          buttonList: [
            // {
            //   id: 4 - 1,
            //   icon: require("../assets/images/play.png"),
            //   text: "播放视频1",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // },
            // {
            //   id: 4 - 3,
            //   icon: require("../assets/images/ppt.png"),
            //   text: "播放视频3",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // }
          ],
          articleList: [
            {
              id: 4 - 1 - 1,
              src: require("../assets/images/newAdd/21.jpg"),
              articletitle: "智能同轴监控套包",
              articledetails: "",
              traitList: [
                {
                  id: 4 - 1 - 1 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "支持H.265+编码，低码流，低存储"
                    },
                    {
                      light: "零延时， 秒出图，传输距离达到500米以上"
                    },
                    {
                      light: "AI智能人脸检测，AI智能人形检测"
                    },
                    {
                      light: "本地硬盘存储+云存储"
                    },
                    {
                      light: "手机短视频报警推送"
                    },
                    {
                      light: "支持同轴升级，同轴控制"
                    },
                    {
                      light: "操作简单，即插即用，自动出图"
                    },
                    {
                      light: "低成本，性价比高"
                    },
                    {
                      light: "闭路电路系统，安全性高"
                    }
                  ]
                },
                {
                  id: 1 - 1 - 1 - 2,
                  lightTitle: "适用场景",
                  lightList: [
                    {
                      light:
                        "广泛应用于学校，工厂，超市，便利店，宠物店等多种监控应用场景"
                    }
                  ]
                }
              ],
              have: true,
              href: "http://www.jufenginfo.com/product-list-432-434-442.html"
            }
          ]
        },
        {
          id: 9,
          title: "带屏WiFi套包",
          details:
            "带屏WiFi套包产品，自带高清显示屏，包含多种高清分辨率，支持一键自动对码接入，自动出图，人形、人脸检测等多种功能，适用于绝大多数场景。",
          buttonList: [
            // {
            //   id: 5 - 1,
            //   icon: require("../assets/images/play.png"),
            //   text: "播放视频1",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // },
            // {
            //   id: 5 - 3,
            //   icon: require("../assets/images/ppt.png"),
            //   text: "播放视频3",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // }
          ],
          articleList: [
            {
              id: 9 - 1 - 1,
              src: require("../assets/images/newAdd/24.jpg"),
              articletitle: "网络带屏WiFi套包",
              articledetails: "",
              traitList: [
                {
                  id: 9 - 1 - 1 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "支持H.265AI编码，低码流，低存储"
                    },

                    {
                      light: "自带高清显示屏，无需额外购买显示器"
                    },
                    {
                      light: "支持一键自动对码接入，自动出图"
                    },
                    {
                      light: "支持自动级联，快速确定最佳级联"
                    },
                    {
                      light: "本地SD卡存储+云存储"
                    },
                    {
                      light: "支持人形、人脸检测"
                    },
                    {
                      light: "无需布线，有效解决布线繁琐的困扰"
                    },
                    {
                      light: "移动性强 ，解决了有线移动性差的困扰"
                    }
                  ]
                },
                {
                  id: 9 - 1 - 1 - 2,
                  lightTitle: "适用场景",
                  lightList: [
                    {
                      light: "适用于景区，公寓，水库等监控应用场景"
                    }
                  ]
                }
              ],
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-312.html"
            }
          ]
        },
        {
          id: 10,
          title: "带屏DVR套包",
          details:
            "带屏DVR套包产品，自带高清显示屏，包含多种高清分辨率，操作简单，即插即用，自动出图，支持人形、人脸检测等多种功能，适用于绝大多数场景。",
          buttonList: [
            // {
            //   id: 5 - 1,
            //   icon: require("../assets/images/play.png"),
            //   text: "播放视频1",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // },
            // {
            //   id: 5 - 3,
            //   icon: require("../assets/images/ppt.png"),
            //   text: "播放视频3",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // }
          ],
          articleList: [
            {
              id: 10 - 1 - 1,
              src: require("../assets/images/newAdd/26.jpg"),
              articletitle: "带屏DVR套包",
              articledetails: "",
              traitList: [
                {
                  id: 10 - 1 - 1 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "支持H.265+编码，低码流，低存储"
                    },

                    {
                      light: "自带高清显示屏，无需额外购买显示器"
                    },
                    {
                      light: "支持同轴升级，同轴控制"
                    },
                    {
                      light: "操作简单，即插即用，自动出图"
                    },
                    {
                      light: "本地硬盘存储+云存储"
                    },
                    {
                      light: "支持人形、人脸检测"
                    },
                    {
                      light: "低成本，性价比高，零延时，秒出图"
                    },
                    {
                      light: "闭路电路系统，安全性高"
                    }
                  ]
                },
                {
                  id: 10 - 1 - 1 - 2,
                  lightTitle: "适用场景",
                  lightList: [
                    {
                      light: "适用于医院，学校，工厂，车库等监控应用场景"
                    }
                  ]
                }
              ],

              href: "http://www.jufenginfo.com/product-list-432-312.html"
            }
          ]
        },
        {
          id: 5,
          title: "电池类套包",
          details:
            "电池摄像机套包无需布线，真正全无线。电池供电，无线配对，可安装在任何地方，安装简单方便。支持智能PIR人体红外感应、手机远程、红外夜视、云存储等功能，带来更多智能体验。",
          buttonList: [
            // {
            //   id: 5 - 1,
            //   icon: require("../assets/images/play.png"),
            //   text: "播放视频1",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // },
            // {
            //   id: 5 - 3,
            //   icon: require("../assets/images/ppt.png"),
            //   text: "播放视频3",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // }
          ],
          articleList: [
            {
              id: 5 - 1 - 1,
              src: require("../assets/images/product/lQDPDhrMurNSzsjNAkTNA5iw4DMTRQ2xyjMBfKvY8kANAA_920_580.jpg_720x720q90g.jpg"),
              articletitle: "电池类摄像机监控套包",
              articledetails: "",
              traitList: [
                {
                  id: 5 - 1 - 1 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "无需布线，真正全无线"
                    },

                    {
                      light: "电池供电，无线配对"
                    },
                    {
                      light: "超强红外夜视"
                    },
                    {
                      light: "智能PIR人体红外感应检测"
                    },
                    {
                      light: "云存储"
                    },
                    {
                      light: "手机短视频报警推送"
                    }
                  ]
                },
                {
                  id: 5 - 1 - 1 - 2,
                  lightTitle: "适用场景",
                  lightList: [
                    {
                      light:
                        "广泛应用于餐厅，面包店，服饰店，便利店，宠物店，家庭住宅等多种监控应用场景"
                    }
                  ]
                }
              ],
              href: "http://www.jufenginfo.com/product-list-432-312.html"
            }
          ]
        }
      ]
    };
  },
  methods: {
    changeShow() {
      this.show = false;
    },
    fn(val) {
      this.show = val;
    },
    getHeight(val) {
      this.msgboxTop = val;
    }
  },
  watch: {
    msgboxTop(val) {
      this.msgboxTop = val;
    }
  }
};
</script>

<style></style>
